import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription,
} from "@/components/ui/dialog";
import { ShareScore } from "@/components/ShareScore";

export function ShareScoreModal({ open, onOpenChange, scanId, host, score }) {
  const cardUrl = scanId
    ? `${process.env.REACT_APP_BACKEND_URL}/api/scans/${scanId}/score-card.png`
    : null;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-[#0C1424] border border-slate-700 text-white sm:max-w-lg" data-testid="share-score-modal">
        <DialogHeader>
          <DialogTitle className="font-heading text-2xl">Your Security Score is ready! 🎉</DialogTitle>
          <DialogDescription className="text-slate-400">
            {host} scored <span className="text-cyanbrand font-semibold">{score}/100</span>. Share your card and
            let people know you take security seriously.
          </DialogDescription>
        </DialogHeader>
        {cardUrl && (
          <img
            src={cardUrl}
            alt={`Security score for ${host}`}
            data-testid="share-card-preview"
            className="w-full rounded-lg border border-slate-700 mt-1"
          />
        )}
        <ShareScore scanId={scanId} host={host} score={score} showHeader={false} />
      </DialogContent>
    </Dialog>
  );
}
